import { ViewType } from 'owa-calendar-actions';
import { canCancel } from 'owa-calendar-event-capabilities';
import { cancelCalendarEvent } from 'owa-calendar-events-actions';
import { lazyOpenNotesEditor } from 'owa-calendar-notes-editor';
import { CalendarEvent } from 'owa-calendar-types';
import { ClientItemId } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import { getCancelMenuItems } from 'owa-event-context-menu';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { cancel } from 'owa-locstrings/lib/strings/cancel.locstring.json';
import EventScope from 'owa-service/lib/contract/EventScope';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

/**
 * Returns the button for cancel
 * @param event Calendar event
 * @param actionSource Calendar view
 * @param onCancelClicked cancel callback
 */
export const getCancelButton = (
    event: CalendarEvent,
    actionSource: ViewType,
    onCancelClicked?: () => void
): FilterableMenuItem => {
    let onClick;
    let menuItems;

    const cancelMenuItems = getCancelMenuItems(
        event,
        createOnCancelItemClicked(event.ItemId, actionSource, onCancelClicked)
    );

    if (cancelMenuItems.length == 1) {
        onClick = cancelMenuItems[0].onClick;
    } else {
        menuItems = cancelMenuItems;
    }

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(cancel),
        [FilterableMenuItemArgs.icon]: ControlIcons.RemoveEvent,
        [FilterableMenuItemArgs.onClick]: onClick,
        [FilterableMenuItemArgs.shouldShow]: () => canCancel(event),
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.menuContent]: menuItems,
        [FilterableMenuItemArgs.key]: 'Cancel',
    });
};

function createOnCancelItemClicked(
    calendarEventId: ClientItemId,
    actionSource: ViewType,
    onCancel?: () => void
): (eventScope: EventScope, editorTitleText: string) => void {
    return (eventScope: EventScope, editorTitleText: string) => {
        lazyOpenNotesEditor.importAndExecute(
            calendarEventId,
            eventScope,
            (eventScope: EventScope, notes?: string) => {
                cancelCalendarEvent(
                    calendarEventId,
                    actionSource,
                    eventScope,
                    getCalendarComponent(actionSource),
                    notes,
                    onCancel
                );
            },
            editorTitleText,
            ControlIcons.RemoveEvent,
            null, // propose new time
            null, // forwardees
            false, // hide notify toggle
            true, // Send response
            true // is Cancelled event
        );
    };
}

function getCalendarComponent(viewType: ViewType): CalendarComponent {
    switch (viewType) {
        case 'SurfacePeek':
            return CalendarComponent.CalendarItemPeek;
        case 'ReadForm':
            return CalendarComponent.CalendarReadForm;
        default:
            return CalendarComponent.Unknown;
    }
}
